import { Box, Container, useTheme } from "@mui/material";
import { CartContext } from "./provider.js";
import { EmptyCart } from "./empty-cart.js";
import { ItemsCardList } from "./items-card-list.js";
import { ItemsTable } from "./items-table.js";
import { Totals } from "./totals.js";
import { useAnalytics } from "../google-analytics/index.js";
import { useMediaQuery } from "../utilities/index.js";
import React from "react";
export const Cart = ({ products = [], sx = {} }) => {
    const theme = useTheme();
    const trackEvent = useAnalytics();
    const isAtLeastSm = useMediaQuery(theme.breakpoints.up("sm"));
    const { cart, isLoading } = React.useContext(CartContext);
    React.useEffect(() => {
        trackEvent("view_cart", {
            currency: cart?.totals.currency_code ?? "EUR",
            value: parseInt(cart?.totals.total_price ?? "0") / 100,
            items: cart?.items.map(({ name, sku, prices, quantity }, index) => ({
                item_id: sku,
                currency: prices.currency_code,
                price: parseInt(prices.price) / 100,
                quantity,
                index,
                item_name: name,
            })) ?? [],
        });
    }, []);
    return (React.createElement(Box, { sx: sx }, !isLoading.getCart && (cart?.items.length === 0 || !cart) ? (React.createElement(Container, { maxWidth: "xl" },
        React.createElement(EmptyCart, null))) : (React.createElement(React.Fragment, null,
        isAtLeastSm ? React.createElement(ItemsTable, { products: products }) : React.createElement(ItemsCardList, { products: products }),
        React.createElement(Totals, null)))));
};
//# sourceMappingURL=cart.js.map